function BoardOfDirectors({ data }) {
    return (
        <div key={data.documentId} className="board-of-directors col-xs-12 col-sm-3 no-padding board-member" style={{fontSize: '16px'}}>
                {data.map((item, index) => (
                    <span>
                            <p className="board-member-name"><strong>{item.name}</strong></p>
                            <p className="">{item.organization}</p>
                    </span>
                ))}
        </div>
    );
}

export default BoardOfDirectors;
